import { api } from './api'
import { TenantSignupData } from '../types'

export interface CreateTenantResponse {
  id?: string
  name?: string
  slug?: string
  email?: string
  message?: string
  token?: string
  tenant?: {
    id: string
    name: string
    slug: string
    is_active: boolean
  }
  admin_user?: {
    id: string
    name: string
    email: string
    role: string
  }
  user?: {
    id: string
    name: string
    email: string
    avatar_url?: string | null
  }
}

export interface FindTenantByEmailResponse {
  tenant: {
    id: string
    name: string
    slug: string
    is_active: boolean
  }
  admin_user: {
    id: string
    name: string
    email: string
    role: string
  }
}

export const tenantService = {
  async createTenant(data: TenantSignupData): Promise<CreateTenantResponse> {
    const payload = {
      name: data.name,
      email: data.email,
      password: data.password,
    }
        
    const response = await api.post<{ data: CreateTenantResponse }>('/api/v1/tenants', payload)
    return response.data.data
  },

  async findTenantByEmail(email: string): Promise<FindTenantByEmailResponse | null> {
    try {
      const response = await api.post<{ data: FindTenantByEmailResponse }>('/api/v1/tenants/find-by-email', {
        email,
      })
      return response.data.data
    } catch (error: any) {
      // Se não encontrar, retorna null
      if (error.response?.status === 404) {
        return null
      }
      throw error
    }
  },
}

